<template>
  <div
    class="invalid-feedback"
    :class="errorClass"
    :style="hasError ? { display: 'block' } : {}"
  >
    <div v-if="errors && errors[field]">
      <div
        v-for="(error, index) in errors[field]"
        :key="index"
        v-html="error"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  errors: Record<string, string[]> | null
  field: string
}>()

const errorClass = computed(() => {
  return 'error-' + props.field
})

const hasError = computed(() => {
  if (!props.errors) {
    return false
  }
  const errors = props.errors[props.field]
  return errors && errors.length > 0
})
</script>
